import { type ThemeOptions } from '@material-ui/core';

/** @deprecated no mui usages */
export const lightModeTheme: ThemeOptions = {
  palette: {
    type: 'light',
  },
};
